<template>
  <div class="row expanded footer-box">
    <div class="small-12 columns title-box">
      <div class="row align-middle">
        <div class="small-12 medium-6 col-center search-us"
             @click="openTeamModal">{{ trans.callUsFirstPart }}
          <span class="black-helper">{{ trans.callUsSecondPart }}</span></div>
        <div class="small-12 medium-6 logo-helper col-center">
          <div class="">
            <img v-if="IS_CORDOVA_APP"
                 :alt="trans.logoAlt"
                 :src="trans.logoUrl"/>
            <img v-else
                 :alt="trans.logoAlt"
                 :src="`/${trans.logoUrl}`"/>
            <span class="site-name"><span class="black-title">
              {{ trans.footerSiteNameFirstPart }}
            </span>{{ trans.footerSiteNameSecondPart }} v{{ CURRENT_VERSION }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <div class="row">
        <div class="small-12 medium-4 col-center clickable"
             @click="openAszfModal">{{ trans.privacyPolicy }}
        </div>
        <div class="small-12 medium-4 col-center clickable"
             @click="openTeamModal">{{ trans.team }}
        </div>
        <div class="small-12 medium-4 col-center clickable"
             @click="openUsesInfoModal">{{ trans.userManual }}
        </div>
        <!--
        <div class="small-12 medium-4 col-center contact-text">???</div>
        <div class="small-12 medium-2 col-center contact-text">???</div>
        <div class="small-12 medium-4 col-center contact-text">???</div>
        -->
      </div>
    </div>
    <div class="small-12 columns">
      <div class="row contact-block">
        <div class="small-12 medium-2 col-center contact-text">{{ trans.contactPhone }}</div>
        <div class="small-12 medium-4 col-center contact-text">{{ trans.contactMail }}</div>
        <div class="small-12 medium-2 col-center contact-text">{{ trans.contactCompanyName }}</div>
        <div class="small-12 medium-4 col-center contact-text">{{ trans.contactAddress }}</div>
      </div>
    </div>
    <aszf-modal/>
    <uses-info-modal/>
    <team-modal :is-mobile-device="isMobileDevice"/>
  </div>
</template>

<script>
import AszfModal from '../modal/AszfModal'
import UsesInfoModal from '../modal/UsesInfoModal'
import TeamModal from '../modal/TeamModal'
import config from '@/config'
import {mapState} from 'vuex'

export default {
  props: ['isMobileDevice'],
  data () {
    return {
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
      CURRENT_VERSION: config.CURRENT_VERSION,
    }
  },
  methods: {
    openAszfModal () {
      // eslint-disable-next-line
      // $('#aszfModal').modal('show')
      this.$modal.show('aszf-modal')
    },
    openUsesInfoModal () {
      // eslint-disable-next-line
      this.$modal.show('uses-info-modal')
    },
    openTeamModal () {
      // eslint-disable-next-line
      this.$modal.show('team-modal')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.footer,
    }),
  },
  components: {
    AszfModal,
    UsesInfoModal,
    TeamModal,
  },
}
</script>

<style scoped>
.footer-box {
  background: #ebecef;
  padding: 1rem 0;
}

.black-helper {
  font-weight: bold;
}

.logo-helper {
  color: #000;
  float: right;
}

.logo-right {
  float: right;
}

.site-name {
  color: #000;
  min-width: 9rem;
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: 3px;
}

img {
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 0.5rem;
}

.black-title {
  font-weight: 800;
  color: #000;
}

.search-us {
  font-size: 2rem;
  cursor: pointer;
}

.col-center {
  text-align: center;
}

.contact-block {
  margin-top: 1rem;
}

.contact-block .contact-text {
  border-left: 1px solid #0a0a0a;
}

.contact-block .contact-text:first-child {
  border: none;
}

.title-box {
  margin-bottom: 1rem;
}

.clickable {
  cursor: pointer;
}
</style>
